import { cn } from 'twyne-new.ui'

export default function ColumnResizer({ canResize = true, onMouseDown, isResizing = false }) {
  if (!canResize) {
    return null
  }

  return <div
    onMouseDown={onMouseDown}
    className={cn(
      'absolute top-0 h-full w-[3px] cursor-col-resize select-none touch-none',
      isResizing ? 'twy-bg-accent opacity-100' : 'twy-subtle-neutral opacity-0 group-hover:opacity-100',
      'right-0',
    )}
  />
}
